import {
  getCoreRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";

import { DataTablePagination } from "@/components/DataTable";
import { usePaginationSearch } from "@/lib/listPage";

import CompleteDialog from "../-components/-import-data/CompleteDialog";
import DataTableCard from "../-components/-preview-file/DataTableCard";
import SearchFilterBar from "../-components/-preview-file/SearchFilterBar";
import Summary from "../-components/-preview-file/Summary";
import type {
  MutateTableRows,
  SearchParams,
  TableColumnDefs,
  TableRows,
} from "../types";

type Props = {
  hash: string;
  unit: string;
  search: SearchParams;
  navigate: (args: { search: SearchParams; hash: string }) => void;
  tableColumnDefs: TableColumnDefs;
  tableRows: TableRows;
  mutateTableRows: MutateTableRows;
  filterError: boolean;
  completeLinkButton: string;
  completeLinkUrl: string;
};

const ImportData = ({
  hash,
  unit,
  search,
  navigate,
  tableColumnDefs,
  tableRows,
  mutateTableRows,
  filterError,
  completeLinkButton,
  completeLinkUrl,
}: Props) => {
  const [pagination, setPagination] = usePaginationSearch({
    search: search,
    onSearchChange: (search) => navigate({ hash, search }),
  });

  // NOTE: フロントエンド側でページネーションしています
  const start = search.pageIndex * search.pageSize;
  const end = start + search.pageSize;
  const paginatedRows = tableRows.rows.slice(start, end);
  const pageCount = Math.ceil(tableRows.rows.length / search.pageSize);

  const table = useReactTable({
    data: paginatedRows,
    pageCount,
    columns: tableColumnDefs,
    initialState: {
      columnPinning: {},
    },
    state: { pagination },
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    onPaginationChange: setPagination,
    // onColumnVisibilityChange: setColumnVisibility,
    // onSortingChange: setSorting,
    manualPagination: true,
    // manualSorting: true,
  });

  return (
    <>
      {tableRows.error.rowsCount > 0 && (
        <>
          <Summary error={tableRows.error} unit={unit} />
          <SearchFilterBar
            mutateTableRows={mutateTableRows}
            error={tableRows.error}
            filterError={filterError}
          />
          <DataTableCard
            table={table}
            rowsCount={tableRows.rows.length}
            error={tableRows.error}
          />
          {tableRows.rows.length > 0 && (
            <div className="w-full p-3">
              <DataTablePagination
                table={table}
                totalCount={tableRows.rows.length}
              />
            </div>
          )}
        </>
      )}

      {tableRows.error.rowsCount === 0 && (
        <CompleteDialog
          completeLinkButton={completeLinkButton}
          completeLinkUrl={completeLinkUrl}
        />
      )}
    </>
  );
};

export default ImportData;
